import { useQuery } from "react-query";
import { getParentHierarchyById } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetParentHierarchyById = (hierarchyId, isParent) => {
  return useQuery(
    ["GetParentHierarchyById", hierarchyId],
    () => getParentHierarchyById(hierarchyId, isParent),
    {
      refetchOnWindowFocus: false,
      enabled: !!hierarchyId,
    }
  );
};
